import React from 'react';

import {SearchBar, Select} from '@/components';
import type {AfriexQueryParams} from '@/types/AfriexQueryParams';

import {
  RFI_SOURCE_FILTER_OPTIONS,
  RFI_STATUS_FILTER_OPTIONS,
} from './rfiStatus';

type BusinessRFIFiltersProps = {
  currentFilters: AfriexQueryParams;
  selectCurrentFilters: (name: string, value: string | undefined) => void;
  selectAppliedFilters: (name: string, value: string | undefined) => void;
  handleApplyFilters: () => void;
  clearFilters: () => void;
  extraAction?: React.ReactNode;
  dataCy?: string;
};

const BusinessRFIFilters = ({
  currentFilters,
  dataCy,
  selectCurrentFilters,
  selectAppliedFilters,
  handleApplyFilters,
  clearFilters,
  extraAction,
}: BusinessRFIFiltersProps) => {
  return (
    <div className="mb-3 w-full">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Left: customer email search (staged, applied on Search) */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center sm:space-x-3 w-full sm:w-3/5 gap-3 max-w-md">
          <SearchBar
            dataCy={dataCy}
            handleSearch={(term: string) => {
              selectAppliedFilters('customerEmail', term || undefined);
              handleApplyFilters();
            }}
            clearFilters={clearFilters}
            inputClassName="w-full"
            placeholder="Search by customer email"
          />
        </div>

        {/* Right: status + source selects (applied immediately) */}
        <div className="flex flex-row flex-wrap sm:flex-nowrap sm:w-2/3 gap-3 items-center md:space-x-3 justify-end">
          <Select
            data-cy={dataCy ? `${dataCy}-status-input` : undefined}
            name="status"
            options={RFI_STATUS_FILTER_OPTIONS}
            placeholder="Filter by status"
            value={currentFilters.status ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              selectCurrentFilters('status', e.target.value || undefined)
            }
            className="w-full sm:w-48"
          />
          {/* Separates the rail-raised holds from the ones a human opened;
              the two need completely different triage. */}
          <Select
            data-cy={dataCy ? `${dataCy}-source-input` : undefined}
            name="source"
            options={RFI_SOURCE_FILTER_OPTIONS}
            placeholder="Filter by source"
            value={currentFilters.source ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              selectCurrentFilters('source', e.target.value || undefined)
            }
            className="w-full sm:w-48"
          />
          {extraAction}
        </div>
      </div>
    </div>
  );
};

export default BusinessRFIFilters;
